<template>
    <Modal :show="showModal" @close="showModal = false" :inHeader="true" :doubleModal="true" :modalClass="'modal-restricted'">
        <template #header>
            <h4 class="modal-title redeem-modal-title">{{ $t('Continue to payment?') }}</h4>
            <p>{{ $t('With some of the products in your order, there may be activation issues in your region.') }}</p>
        </template>
        <template #body>
            <ScrollFade fade-top-class="faded-top" fade-bottom-class="faded" :class="regionMismatchProducts.length < 4 ? 'no-fade' : ''">
                <div class="modal-body__product-item" 
                    v-for="product in regionMismatchProducts" 
                    :key="product.id">
                    <div class="item__product-img">
                        <img :src="product.img.src" :alt="product.img.alt" :title="product.img.title">
                    </div>
                    <div class="item__info">
                        <div class="item__info-title">{{ product.title }}</div>
                        <div class="item__info-region-wrap" :ref="'regionInfoWrap_' + product.id">
                            <div class="item__info-region">
                                <img v-if="product.region?.is_restricted" src="/img/tmp/region-load.svg?=v1" alt="region">
                                <img v-else src="/img/tmp/region-decline.svg?=v1" alt="region">
                                <div class="item__info-animate" :class="{'animate-title': addAnimateToRegion[product.id]}">
                                    <span class="item__info-region-text">
                                        <p :ref="'regionInfoText_' + product.id" v-html="product.region?.is_restricted ? $t('Activation in {country} may be difficult', { 
                                            country: `<span>${$t('your region')}</span>`
                                        }) : $t(`Can't be activated in {region}`, { 
                                            region: `<span>${$t('your region')}</span>`
                                        })"></p>
                                        <p v-if="addAnimateToRegion[product.id]" v-html="animateText[product.id]"></p>
                                        <p v-if="addAnimateToRegion[product.id]" v-html="animateText[product.id]"></p>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ScrollFade>
            <div class="button-block text-center">
                <button type="button" class="button cancel btn-hover btn-hover--gray" @click="showModal = false">
                    <span>{{ $t('Back') }}</span>
                </button>
                <a href="/checkout" class="button button-accent button--positive btn-hover btn-hover--green js-btn-preloader-green-onAccepted">
                    <span>{{ $t('Continue') }}</span>
                </a>
            </div>
        </template>
    </Modal>
</template>
  
<script>
import Modal from '/webpack-assets/vue/components/Modal.vue';
import Button from '/webpack-assets/vue/components/Button.vue';
import ScrollFade from '/webpack-assets/vue/components/ScrollFade.vue';
import { ref, onMounted, nextTick } from 'vue';

  export default {
    name: 'ModalRegion',
    components: {
      Modal,
      Button,
      ScrollFade
    },
    props: {
        mobile: {
            type: Boolean,
            default: false,
        },
        language: {
            type: String,
            default: 'en',
        },
        isModalRegionActive: {
            type: Boolean,
            default: false,
        },
        regionMismatchProducts: {
            type: Array,
            default: () => [],
        },
    },
    data() {
      return {
        showModal: false,
        animateText: {},
        addAnimateToRegion: {},
      };
    },
    methods: {
        getRegionInfoWidths(productId) {
            let textEl = this.$refs['regionInfoText_' + productId];
            let wrapEl = this.$refs['regionInfoWrap_' + productId];
            if (Array.isArray(textEl)) textEl = textEl[0];
            if (Array.isArray(wrapEl)) wrapEl = wrapEl[0];

            if (!textEl || !wrapEl) return;
            
            const textWidth = textEl.offsetWidth || 0;
            const wrapWidth = wrapEl.offsetWidth || 0;

            if (wrapWidth - 27 < textWidth) {
                this.addAnimateToRegion[productId] = true;
                this.animateText[productId] = textEl.innerHTML || '';
            }
        },
    },
    watch: {
        isModalRegionActive(val) {
            this.showModal = val;
        },
        showModal(val) {
            if(val) {
                nextTick(() => {
                     setTimeout(() => {
                        this.regionMismatchProducts.forEach(product => {
                            this.getRegionInfoWidths(product.id);
                        });
                    }, 1000);
                });
            } else {
                this.addAnimateToRegion = {};
                this.animateText = {};
                this.$emit('close-modal-region');
            }
        }
    }
  };
  </script>

<style lang="scss">
.modal-restricted{
    @media only screen and (max-width: 767px) {
        border-radius: 0;
        top: 0 !important;
    }
    .modal-header{
        flex-direction: column;
        .modal-title{
            font-family: "Roboto-Medium", sans-serif;
            font-weight: 400;
            font-size: 22px;
            line-height: 1.36364;
            text-transform: uppercase;
            color: #f6f6f6;
            padding-top: 24px;
            padding-bottom: 20px;
            @media only screen and (max-width: 767px) {
                font-size: 18px;
            }
        }
        p{
            font-family: "Roboto-Light", sans-serif;
            font-weight: 400;
            font-size: 16px;
            line-height: 1.5;
            text-align: center;
            color: #9ba1ab;
            @media only screen and (max-width: 767px) {
                font-size: 14px;
            }
        }
    }
    .modal-body{
        padding: 0 30px 30px;
        .scroll-fade{
            max-height: 280px;
            overflow-x: hidden;
        }
        &__product-item{
            background: linear-gradient(90deg, #2b3545 0%, #2b3545 100%);
            border-radius: 12px;
            height: 75px;
            overflow: hidden;
            display: flex;
            flex-wrap: nowrap;
            @media only screen and (max-width: 767px) {
                flex-direction: column;
                height: auto;
            }
            &:not(:last-child){
                margin-bottom: 5px;
            }
            .item{
                &__product-img{
                    min-width: 150px;
                    width: 150px;
                    height: 75px;
                    @media only screen and (max-width: 767px) {
                        width: 100%;
                        height: 164px;
                        overflow: hidden;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        img{
                            max-width: 100%;
                            width: 100%;
                            height: auto;
                        }
                    }
                }
                &__info{
                    width: 100%;
                    max-width: 290px;
                    padding: 12px 20px;
                    display: flex;
                    flex-direction: column;
                    @media only screen and (max-width: 767px) {
                        max-width: 100%;
                    }
                    &-animate{
                        display: inline-flex;
                        align-items: center;
                        overflow: hidden;
                        margin-left: 5px;
                        @keyframes textAnimation {
                            0% {
                                transform: translateX(0%);
                            }
                            20% {
                                transform: translateX(0%);
                            }
                            100% {
                                transform: translateX(-100%);
                            }
                        }
                        @keyframes fadeAnimation {
                            0% {
                                -webkit-mask-image: linear-gradient(
                                90deg,
                                transparent,
                                black 0% 90%,
                                transparent
                                );
                            }
                            20% {
                                -webkit-mask-image: linear-gradient(
                                90deg,
                                transparent,
                                black 0% 90%,
                                transparent
                                );
                            }
                            21% {
                                -webkit-mask-image: linear-gradient(
                                90deg,
                                transparent,
                                black 10% 90%,
                                transparent
                                );
                            }
                            100% {
                                -webkit-mask-image: linear-gradient(
                                90deg,
                                transparent,
                                black 10% 90%,
                                transparent
                                );
                            }
                        }
                        &.animate-title{
                            -webkit-mask-image: linear-gradient(-90deg, black 96%, transparent);
                            span{
                                animation: textAnimation 15s linear infinite;
                            }
                        }
                    }
                    &-title{
                        font-family: "Roboto-Medium", sans-serif;
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 1.4;
                        color: #f6f6f6;
                        white-space: nowrap;
                        -webkit-mask-image: linear-gradient(90deg, black 90%, transparent);
                        margin-bottom: 15px;
                    }
                    &-region{
                        display: inline-flex;
                        align-items: center;
                        &-wrap{
                            overflow-x: hidden;
                            min-height: 19px;
                            -webkit-mask-image: linear-gradient(90deg, black 90%, transparent);
                        }
                        img{
                            width: 16px;
                            height: 16px;
                            margin-right: 0;
                        }
                        &-text{
                            white-space: nowrap;
                            p{
                                margin: 0;
                                font-family: "Roboto-Light", sans-serif;
                                font-weight: 400;
                                font-size: 12px;
                                display: inline-block;
                                line-height: 1.5;
                                white-space: nowrap;
                                color: #c0c3c9;
                                text-align: start;
                                margin-right: 20px;
                                span{
                                    color: #f6f6f6;
                                }
                            }
                        }
                    }
                }
            }
        }
        .button-block{
            display: flex;
            @media only screen and (max-width: 767px) {
                flex-direction: column;
                .cancel{
                    margin-bottom: 20px;
                }
            }
            .button{
                font-family: "Roboto-Medium";
                font-weight: 400;
                max-width: 100%;
            }
        }
    }
}
</style>